/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DocumentErrors from './DocumentErrors';
import DocumentStatus from './DocumentStatus';
import DocumentType from './DocumentType';
import MessageType from './MessageType';

/**
 * The Document model module.
 * @module model/Document
 * @version 1.0.0
 */
class Document {
    /**
     * Constructs a new <code>Document</code>.
     * Uploaded file
     * @alias module:model/Document
     * @param id {Number} 
     * @param name {String} 
     * @param type {module:model/DocumentType} 
     * @param status {module:model/DocumentStatus} 
     * @param errors {Array.<module:model/DocumentErrors>} 
     */
    constructor(id, name, type, status, errors) { 
        
        Document.initialize(this, id, name, type, status, errors);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, name, type, status, errors) { 
        obj['id'] = id;
        obj['name'] = name;
        obj['type'] = type;
        obj['status'] = status;
        obj['errors'] = errors;
    }

    /**
     * Constructs a <code>Document</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Document} obj Optional instance to populate.
     * @return {module:model/Document} The populated <code>Document</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Document();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = DocumentType.constructFromObject(data['type']);
            }
            if (data.hasOwnProperty('mime_type')) {
                obj['mime_type'] = ApiClient.convertToType(data['mime_type'], 'String');
            }
            if (data.hasOwnProperty('extension')) {
                obj['extension'] = ApiClient.convertToType(data['extension'], 'String');
            }
            if (data.hasOwnProperty('size')) {
                obj['size'] = ApiClient.convertToType(data['size'], 'Number');
            }
            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'Number');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('messages')) {
                obj['messages'] = ApiClient.convertToType(data['messages'], [MessageType]);
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = DocumentStatus.constructFromObject(data['status']);
            }
            if (data.hasOwnProperty('errors')) {
                obj['errors'] = ApiClient.convertToType(data['errors'], [DocumentErrors]);
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
Document.prototype['id'] = undefined;

/**
 * @member {String} name
 */
Document.prototype['name'] = undefined;

/**
 * @member {module:model/DocumentType} type
 */
Document.prototype['type'] = undefined;

/**
 * @member {String} mime_type
 */
Document.prototype['mime_type'] = undefined;

/**
 * @member {String} extension
 */
Document.prototype['extension'] = undefined;

/**
 * @member {Number} size
 */
Document.prototype['size'] = undefined;

/**
 * @member {Number} version
 */
Document.prototype['version'] = undefined;

/**
 * @member {Date} created_at
 */
Document.prototype['created_at'] = undefined;

/**
 * Message types array with related messages
 * @member {Array.<module:model/MessageType>} messages
 */
Document.prototype['messages'] = undefined;

/**
 * @member {module:model/DocumentStatus} status
 */
Document.prototype['status'] = undefined;

/**
 * @member {Array.<module:model/DocumentErrors>} errors
 */
Document.prototype['errors'] = undefined;






export default Document;

